// Assessment page shortcuts for the Shortcuts dialog: moving through the results, opening a topic and moving between topics in the open sheet.
import type { ShortcutDef } from "@/app/shortcuts";

export const ASSESSMENT_SHORTCUTS: readonly ShortcutDef[] = [
  { id: "assessment-move", keys: [["↓"], ["↑"]], description: "Next or previous topic in the results" },
  { id: "assessment-open", keys: [["Enter"]], description: "Open the selected topic" },
  { id: "assessment-sheet", keys: [["J"], ["K"]], description: "Next or previous topic in the open topic" },
];
